import React from 'react'
import "./TermsCondition.css"
import { Link, useNavigate } from 'react-router-dom';
function ShippingPolicy() {
    const navigate = useNavigate();
    const previouseScreen = () => {
        navigate(-1);
    }
    return (
        <div class="container-fluid  global_container BathHeader">
            <div className='p-3'>


                <div className="row mb-2">
                    <div className="col-md-6 col-12">
                        <h2 className="TitleHeader"> Shipping Policy </h2>
                    </div>
                    <div className="col-md-6 col-12 ListBtn">
                        <ul class="List-Button">
                            <li class="ListBtnItems">
                                <Link
                                    to={"javascript:void(0)"}
                                    onClick={previouseScreen}
                                    className="secondaryButton "
                                    variant="secondary"
                                >
                                    Back
                                </Link>
                            </li>


                        </ul>
                    </div>
                </div>
                <div class="">
                    <p>
                        At AIASA Book Publications, we are committed to delivering your books, study materials, and other items safely and efficiently. Please take a moment to review our shipping policy below.
                    </p>
                    <p>
                        These terms and conditions (hereinafter referred to as Terms) governs the manner in which
                        ANNA IAS ACADEMY BOOK PUBLICATIONS (hereinafter referred to as AIASA BOOK
                        PUBLICATIONS) collects, uses, maintains and discloses information collected from users of the <a style={{ fontWeight: "bold" }} href='/'>www.annaiasacademy.com</a> website and the business operation of AIASA BOOK PUBLICATIONS.

                    </p>

                    
                    <a href='#' className="subTitleHeader">COURIER CHARGES</a>
                    <p className='pt-3'>
                        The Courier charges collected by the AIASA Book Publication based on the wait of the book
                        and the charges will be applicable each item of the goods / Articles / Books / Study Material offered
                        by the AIASA Book Publications. The charges may be vary and differ whenever the Courier charges
                        Rates are revised by the delivery authority.
                    </p>
                    <a href='#' className="subTitleHeader">REWARD POINTS </a>
                    <p className='pt-3'>
                        Reward points is a promotional point. The reward points is completely discretionary of the
                        AIASA Book Publications authority and no user can claim as a right by using the enforcing law. The
                        announced reward points can cancel by the authority at any time. The user may use their reward
                        points, which was earned by them within the stipulated period announced by the AIASA Book
                        Publications. If the reward points once lapsed / cancelled by the AIASA Book Publications no user
                        can claim.
                    </p>

                    <a href='#' className="subTitleHeader">DELIVERY MODE
                    </a>
                    <p className='pt-3'>
                        The AIASA Book Publications offered the two types of delivery mode. One is Courier Delivery
                        and another one is Branch pickup. The user can choose either any one of the options and collect
                        the book accordingly. If the user choose the courier delivery and try to collect the book through
                        branch pickup at anyway the courier charges cannot be refund at any time. If the user who has choose, the branch pickup can raised a request at branch to send a
                        courier delivery by paying the additional cost of courier charges. In the mode of delivery any
                        discrepancies and difficulties or any delayed faced by the user, the user should directly contact the
                        courier authority in such cases AIASA BOOK PUBLICATIONS is no way responsible for the delaines
                        and difficulties.

                    </p>
                </div>
            </div>
        </div>
    )
}

export default ShippingPolicy;